export default __webpack_public_path__ + "static/media/Travel.95f95af0.svg";